import React, { useState } from "react";

import { client, apiEndpoints, serverUrl, assetBase } from "../../config";

import PostSingle from "../../partials/posts/postSingle";
import PostImage from "../../partials/postImage";
import ClientTheme from "../../core/clientTheme";
import UserImage from "../../partials/userImage";
import PostTitle from "../../partials/postTitle";
import PostBody from "../../partials/postBody";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import { Box, Typography, Link } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import TimeIcon from "@mui/icons-material/AccessTimeOutlined";
import CalendarIcon from "@mui/icons-material/CalendarTodayOutlined";
import PhoneIcon from "@mui/icons-material/PhoneOutlined";
import MailIcon from "@mui/icons-material/EmailOutlined";
import LinkIcon from "@mui/icons-material/LinkOutlined";
import PinIcon from "@mui/icons-material/PlaceOutlined";
import LocationIcon from "@mui/icons-material/LocationOnOutlined";

export default function CompanyDirectorySingle(props) {
  const [post, setPost] = useState(null);

  const clientTheme = { ...ClientTheme() };

  // Preview reads the draft image off the CMS host; the published view resolves
  // it from the entity's published dir via assetBase (same-origin on deployed
  // hosts), where field_featured_image is a signed relative `assets/…?sig=`
  // path from book.json. Mirrors eventSingle/postSingle. UserImage would
  // otherwise force a serverUrl prefix, breaking the published asset path.
  const featuredImageSrc = post?.field_featured_image
    ? props.preview
      ? `${serverUrl}/${post.field_featured_image}`
      : `${assetBase}/company_directory/${post.id}/${post.id}/${post.field_featured_image}`
    : "";

  const infoProperty = (propertyString, icon) => {
    return (
      <Col xs={5} sm={3}>
        <Row className="ps-4 ms-2">
          <Col xs={"auto"} className="pe-3">
            {icon}
          </Col>
          <Col className="px-0">
            <Typography
              owner="client"
              variant="body2"
              color="clientText.main"
              lh="x-wide"
              weight="bold"
              singles="true"
            >
              {propertyString}:
            </Typography>
          </Col>
        </Row>
      </Col>
    );
  };

  const infoValue = (valueString, link) => {
    return (
      <Col xs={7} sm={9} className="flex-grow-1 ps-4">
        <Row>
          <Col>
            <Typography
              owner="client"
              variant="body2"
              className="d-flex justify-content-between"
              color="clientText.main"
              lh="x-wide"
              weight="light"
              singles="true"
            >
              {link ? (
                <Link
                  owner="client"
                  variant="body2"
                  className="d-flex justify-content-between w-100"
                  singles="true"
                  weight="light"
                  lh="x-wide"
                  color="clientText.main"
                  hoverbehavior={clientTheme.components.link.hoverbehavior}
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                >
                  {valueString}
                  <OpenInNewIcon fontSize="small" color="clientPrimary" />
                </Link>
              ) : (
                valueString
              )}
            </Typography>
          </Col>
        </Row>
      </Col>
    );
  };

  return (
    <PostSingle
      preview={props.preview}
      apiEndpoint={apiEndpoints.company_directory}
      entityFavoritesContentType={"event"}
      previewReturnRoute={"/company_directory-creator"}
      returnRoute={"/company_directory"}
      backBtnText={"Company Directory Library"}
      screenClassName={"company_directory"}
      logCustomEventType={"company_directory"}
      entityType={"company_directory"}
      disableTitle={true}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
      squareImage
    >
      {post && (
        <>
          <Row className="information-heading-container justify-content-center mb-4">
            <Col xs={5} sm={3} className="avatar-container mb-4 mb-sm-0">
              <UserImage
                className="ratio ratio-1x1"
                owner="client"
                sub_variant="user-image"
                name={post.title}
                imageSrc={featuredImageSrc}
              />
            </Col>
            <Col xs={7} sm={9} className="contact-info-container ps-4">
              <Row className="mb-3">
                <Col>
                  <PostTitle
                    title={post.title}
                    owner="client"
                    titleColor="clientHeading.items"
                    headingLevel={"h1"}
                    lh="medium"
                  />
                </Col>
              </Row>
              <Row className="company-directory-body mb-3">
                <Col xs={12}>
                  <div className="article__body">
                    <PostBody body={post.summary} />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          {(post.field_opening_times || post.field_address) && (
            <Row className="company-directory-information-body-container mb-4">
              <Col className="" xs={12}>
                {post.field_opening_times && (
                  <Row className="company-directory-hours d-flex align-items-center mb-3">
                    {infoProperty(
                      "Office hours",
                      <TimeIcon fontSize="small" color="clientPrimary" />,
                    )}
                    {infoValue(`${post.field_opening_times}`, false)}
                  </Row>
                )}
                {post.field_address && (
                  <Row className="company-directory-location d-flex align-content-center align-items-center mb-3">
                    {infoProperty(
                      "Location",
                      <LocationIcon fontSize="small" color="clientPrimary" />,
                    )}
                    {infoValue(
                      `${post.field_address}`,
                      `http://maps.google.com/?q=${post.field_address}`,
                    )}
                  </Row>
                )}
              </Col>
            </Row>
          )}
        </>
      )}
    </PostSingle>
  );
}
